import React from 'react';
import { Row, Col } from 'react-bootstrap';

import TextColumn from './columns/text-column';
import ImageColumn from './columns/image-column';

import { colors } from '../../shared/colors';

import { SplitColumnType } from '../../models/strapi/split_column';

interface Props {
    data: SplitColumnType;
    usingMouse: boolean;
    onClickFunctions: {
        [key: string]: () => void;
    };
}

const renderColumns = (
    data: SplitColumnType,
    leftColumnSize: number,
    rightColumnSize: number,
    usingMouse: boolean,
    onClickFunctions: {
        [key: string]: () => void;
    }
) => {
    const imageOnLeft = data.leftSide[0] && data.leftSide[0].image ? true : false;
    const imageOnRight = data.rightSide[0] && data.rightSide[0].image ? true : false;

    return (
        <Row className='g-0'>
            <Col
                xs={{
                    span: 12,
                    order: imageOnRight ? 12 : 1
                }}
                md={{ span: 6, order: 1 }}
                lg={{ span: leftColumnSize, order: 2 }}
                style={{
                    backgroundColor: data.leftColumnBackgroundColor
                        ? colors[data.leftColumnBackgroundColor.backgroundColor]
                        : 'transparent'
                }}>
                {imageOnLeft ? (
                    <ImageColumn
                        onClickFunctions={onClickFunctions}
                        data={data.leftSide[0]}
                        isImageLeft={true}
                        variant={data.variant}
                        textBackgroundColor={
                            data.rightColumnBackgroundColor
                                ? data.rightColumnBackgroundColor.backgroundColor
                                : 'transparent'
                        }
                    />
                ) : (
                    <TextColumn
                        onClickFunctions={onClickFunctions}
                        data={data.leftSide[0]}
                        isImagePadded={!!(data.rightSide[0].image && data.rightSide[0].padding)}
                        isLeftColumn={true}
                        variant={data.variant}
                        bothTextColumns={!imageOnRight}
                        usingMouse={usingMouse}
                    />
                )}
            </Col>
            <Col
                xs={{
                    span: 12,
                    order: imageOnRight ? 1 : 12
                }}
                md={{ span: 6, order: 2 }}
                lg={{ span: rightColumnSize, order: 2 }}
                style={{
                    backgroundColor: data.rightColumnBackgroundColor
                        ? colors[data.rightColumnBackgroundColor.backgroundColor]
                        : 'transparent'
                }}>
                {imageOnRight ? (
                    <ImageColumn
                        onClickFunctions={onClickFunctions}
                        data={data.rightSide[0]}
                        isImageLeft={false}
                        variant={data.variant}
                        textBackgroundColor={
                            data.leftColumnBackgroundColor
                                ? data.leftColumnBackgroundColor.backgroundColor
                                : 'transparent'
                        }
                    />
                ) : (
                    <TextColumn
                        onClickFunctions={onClickFunctions}
                        data={data.rightSide[0]}
                        isImagePadded={!!(data.rightSide[0].image && data.rightSide[0].padding)}
                        isLeftColumn={false}
                        variant={data.variant}
                        bothTextColumns={!imageOnLeft}
                        usingMouse={usingMouse}
                    />
                )}
            </Col>
        </Row>
    );
};

const StrapiSplitColumn = ({ data, usingMouse, onClickFunctions }: Props) => {
    let leftColumnSize = 6;
    let rightColumnSize = 6;

    switch (data.variant) {
        case 'fourty_sixty': {
            leftColumnSize = 5;
            rightColumnSize = 7;
            break;
        }
        case 'sixty_fourty': {
            leftColumnSize = 7;
            rightColumnSize = 5;
            break;
        }
        default: {
            break;
        }
    }

    return renderColumns(data, leftColumnSize, rightColumnSize, usingMouse, onClickFunctions);
};

export default StrapiSplitColumn;
